import { render } from "./Form.vue?vue&type=template&id=b47dc0b8"
import script from "./Form.vue?vue&type=script&lang=ts"
export * from "./Form.vue?vue&type=script&lang=ts"
script.render = render

export default script